export const integrationStateActive = "on";
export const integrationStateDeactivatedByUser = "deactivated-user";
export const integrationStateDeactivatedGeneric = "deactivated";
export const integrationStateDeactivatedExpiredAuth =
  "deactivated-expired-auth";

export const authReasonNoCredentials = "no_credentials";
export const authReasonExpired = "expired";
export const authReasonWrongCredentials = "wrong_credentials";

export const emptyServiceCredentials = "empty_credentials";
export const invalidServiceCredentials = "invalid_credentials";

export const masterAccountID = 1;

export const testEmailID = -1;

export const transactionalAdHocEmailID = -12345;

export const peoplePageSize = 100;

export const screenshotsURL = "https://screenshots.encharge.io";

export const emailValidationAPIURL =
  process.env.EMAIL_VALIDATION_API_URL ||
  "https://email-validation.encharge.io";
export const emailValidationAPIKey = process.env.EMAIL_VALIDATION_API_KEY;

export const appURL =
  process.env.APP_URL ||
  // This needs to be in brackets or it will default to staging-app for some reason
  // eslint-disable-next-line no-nested-ternary
  (process.env.NODE_ENV === "staging"
    ? "https://staging-app.encharge.io"
    : process.env.NODE_ENV === "development"
    ? "https://development-app.encharge.io"
    : "https://app.encharge.io");

export const apiURL = process.env.URL_BASE || "https://api.encharge.io";

export const defaultUnsubscribeSuccessURL = `${appURL}/unsubscribed.html`;

export const maxEmailSpamBlockRetries = 2;

export const maxTestEmails = 5;

export const replyDomain = "reply.encharge-mail.com";

export const enchargeSiteTrackingSlug = "encharge-js";

export const requireMailingAddressInEmailsFromAccountId = 11043;

export const ourEnchargeAccountId =
  process.env.NODE_ENV === "production" ? 88 : 2;

export const maxPersonFieldLength = 5000;

// How many people can we export at once?
export const maxExportPeopleChunkSize = 50000;

export const nativeFormMarketingConsentField = "nativeFormMarketingConsent";

// Name of the tracking consent checkbox in a native form submission.
export const nativeFormTrackingConsentField = "nativeFormTrackingConsent";

// Hidden input rendered next to the tracking consent checkbox (value "1").
// Its presence proves the submitter was shown the checkbox, so an unticked
// box can mean "denied". Without it (an old embed, or plain HTML exported
// before the checkbox was added) the submission leaves trackingConsent alone.
export const nativeFormTrackingConsentShownField =
  "nativeFormTrackingConsentShown";

// The words of {{person.stopTrackingLink}} in an email, and of the button on
// the page it opens. An account can replace them (its customised preferences
// page texts use this sentence as the key).
export const stopTrackingLinkDefaultText = "Refuse email tracking";

export const integrationGoalMetricCacheKeyPrefix = `integrationGoalMetric`;

export const defaultControlVariantId = "00000000-0000-0000-0000-000000000000";

/**
 * The dark-theme colour variants the app ships.
 *
 * Canonical: the frontend's theme manager and the API's appearance endpoint
 * both read this, so adding a variant cannot leave the server silently
 * dropping it - which would apply locally and never follow the user to
 * another machine, with no error anywhere.
 *
 * Two copies cannot import it and are checked by a test instead: the palettes
 * in _dark.scss (CSS) and the pre-paint map in public/index.html (inline
 * script that must run before any bundle loads).
 */
// Deliberately plain: every other value in this file is JS-compatible, and the
// frontend loads it without TypeScript processing - `as const` here broke the
// build. The matching union type lives in the frontend's theme.ts and is held
// in step by variants.consistency.spec.ts.
export const darkVariantNames = [
  "charcoal",
  "midnight",
  "carbon",
  "espresso",
  "forest",
  // The softer family: one lighter sibling per cast above, in the same order.
  "slate",
  "dusk",
  "ash",
  "latte",
  "sage",
];
